module.exports = "/packs/thumbnail-top-cbe949762b3590d9ccb57a39cd16ae9a.png";